export const MAJORS = [
  "Mechanical Engineering",
  "Computer Engineering",
  "Electrical Engineering",
  "Chemical Engineering",
  "Materials Engineering",
  "Mineral Engineering",
  "TrackOne Engineering",
  "Civil Engineering",
  "Engineering Science",
  "Life Science",
  "Social Science",
  "Computer Science",
  "Physical/Math Sciences",
  "Physics",
  "Chemistry",
  "Biology",
  "Economics",
  "Rotman Commerce",
  "Criminology",
  "Architecture",
  "Sociology",
  "Psychology",
  "Other",
];

export const STUDY_YEARS = [
  "1st Year",
  "2nd Year",
  "3rd Year",
  "4th Year",
  "Graduate",
];

export const MAJOR_COLORS = {
  "Mechanical Engineering": "green",
  "Computer Engineering": "blue",
  "Electrical Engineering": "purple",
  "Chemical Engineering": "orange",
  "Materials Engineering": "teal",
  "Mineral Engineering": "brown",
  "TrackOne Engineering": "cyan",
  "Civil Engineering": "gray",
  "Engineering Science": "pink",
  "Life Science": "green",
  "Social Science": "yellow",
  "Computer Science": "blue",
  "Physical/Math Sciences": "red",
  Physics: "purple",
  Chemistry: "orange",
  Biology: "green",
  Economics: "yellow",
  "Rotman Commerce": "blue",
  Criminology: "red",
  Architecture: "gray",
  Sociology: "purple",
  Psychology: "pink",
  Other: "gray",
};
